import React, {
  createContext,
  useState,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import { shallowEqual, useSelector } from "react-redux";

const StudentFamilyBranchContext = createContext();
const SFB_URL = "/api/studentfamilybranch";
export const useStudentFamilyBranch = () => {
  return useContext(StudentFamilyBranchContext);
};

export const StudentFamilyBranchProvider = ({ children }) => {
  const token = useSelector((state) => state.auth.authToken, shallowEqual);
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  const [studentSearchResults, setStudentSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastQuery, setLastQuery] = useState(null);

  const searchStudents = useCallback(
    async (query) => {
      if (!token || !branch?.branch_id) {
        return;
      }
      setLoading(true);
      setError(null);
      setLastQuery(query);
      const searchTerm = query?.search || " ";
      try {
        const response = await axios.get(
          `${SFB_URL}/student-search/${searchTerm}`,
          {
            headers: {
              "x-auth-token": token,
            },
          }
        );
        console.log(response.data);
        setStudentSearchResults(response.data);
      } catch (err) {
        setError(err);
        setStudentSearchResults([]);
      } finally {
        setLoading(false);
      }
    },
    [token, branch]
  );

  const reSearchStudents = useCallback(() => {
    if (lastQuery) {
      searchStudents(lastQuery);
    }
  }, [searchStudents, lastQuery]);

  const studentFamilyContext = {
    studentSearchResults,
    loading,
    error,
    searchStudents,
    reSearchStudents,
    currentBranch: branch,
  };

  return (
    <StudentFamilyBranchContext.Provider value={studentFamilyContext}>
      {children}
    </StudentFamilyBranchContext.Provider>
  );
};
